import ENV from 'signin-app/config/environment';
import { Headers } from '@famly/vet_apollo_client';
import LocalStorageService from 'web-app/services/local-storage';
import { generateUUID } from '@famly/vet_ts-utils_generate-uuid';
import getInstallationId from 'web-app/services/installation-id-manager';
import { getLoginData } from 'signin-app/api/helpers/local-storage';
class APIHelper {
    constructor() {
        this.apiConfigs = ENV.APP.apiConfigs;
        this.initConfig(LocalStorageService.getFromLocalStorage('apiKey'));
    }
    getApiUrlByKey(key) {
        return this.getConfigByKey(key).api;
    }
    getGraphQLUrlByKey(key) {
        return this.getConfigByKey(key).graphql;
    }
    getRequestHeaders(authenticated) {
        const headers = {};
        const installationId = getInstallationId();
        if (authenticated) {
            headers[Headers.XFamlyAccesstoken] = getLoginData().accessToken;
        }
        // Request identifier that the backend returns in the response, allowing the frontend to verify that the request
        // matches the response
        const requestUUID = generateUUID();
        headers[Headers.XFamlyRequestUuid] = requestUUID;
        headers[Headers.XFamlyPlatform] = 'signin/v2';
        if (installationId) {
            headers[Headers.XFamlyInstallationId] = installationId;
        }
        return {
            headers,
            requestUUID,
        };
    }
    get baseConfig() {
        const baseAPIConfig = this.apiConfigs.find(conf => conf.isBase);
        if (baseAPIConfig) {
            return baseAPIConfig;
        }
        throw new Error(`No baseConfig found in apiConfigs`);
    }
    get apiKeys() {
        return this.apiConfigs.map(conf => conf.key);
    }
    get apiConfig() {
        if (this.savedAPIKey && ENV.APP.apiConfigs.length > 1) {
            return this.getConfigByKey(this.savedAPIKey);
        }
        // If there is an accessToken but no savedAPIKey
        // return the baseConfig since they can't be logged in to a new tld
        else if (getLoginData().accessToken) {
            return this.baseConfig;
        }
        else {
            return this.apiConfigs[0];
        }
    }
    // apiConfig setter can't be used because setter's argument
    // must be of the same type as the return type of its getter
    setApiConfig(key) {
        if (this.apiKeys.includes(key)) {
            LocalStorageService.saveToLocalStorage('apiKey', key);
            this.initConfig(key);
        }
        else {
            throw new Error(`Set apiConfig - API config not found: ${key}`);
        }
    }
    get baseUrl() {
        return `${window.location.origin}/`;
    }
    get apiKey() {
        return this.apiConfig.key;
    }
    get apiUrl() {
        return this.apiConfig.api;
    }
    get famlyapiUrl() {
        return this.apiConfig.famlyapi;
    }
    get graphqlUrl() {
        return this.apiConfig.graphql;
    }
    initConfig(key) {
        this.savedAPIKey = key;
    }
    getConfigByKey(key) {
        const config = this.apiConfigs.find(conf => conf.key === key);
        if (config) {
            return config;
        }
        throw new Error(`getConfigByKey - API config not found: ${key}`);
    }
}
const apiHelper = new APIHelper();
export default apiHelper;
